
export const ContactSection = () => {
  const contactInfo = [
    {
      icon: 'ri-mail-line',
      title: 'Email Support',
      info: 'support@duvankadoo.com',
      action: () => window.location.href = 'mailto:support@duvankadoo.com'
    },
    {
      icon: 'ri-phone-line',
      title: 'Call Us',
      info: '+1 3256664206',
      action: () => window.location.href = 'tel:+13256664206'
    },
    {
      icon: 'ri-map-pin-line',
      title: 'Visit Us',
      info: 'Bulevar Oslobodilaca Cacka 105G\nCacak, 520288\nSerbia',
      action: null
    }
  ];

  return (
    <section id="contact" className="py-20 bg-navy-900 relative overflow-hidden">
      <div 
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/3f6ab67f3b0505ac4dafd6bac2a541b2.jpg')`
        }}
      />
      
      <div className="relative z-10 container mx-auto px-6">
        <div className="text-center mb-16">
          <h3 className="text-4xl md:text-5xl font-serif text-white mb-6">
            Get In Touch
          </h3>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Ready to secure your digital privacy? Contact our team for support and inquiries.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
          {contactInfo.map((contact, index) => (
            <div 
              key={index}
              className={`text-center p-8 rounded-2xl transition-all duration-300 hover:scale-105 ${
                contact.action ? 'cursor-pointer hover:bg-cyan-400/10 hover:shadow-lg hover:shadow-cyan-400/20' : ''
              }`}
              onClick={contact.action || undefined}
            >
              <div className="w-16 h-16 bg-cyan-400 rounded-full flex items-center justify-center mx-auto mb-6">
                <i className={`${contact.icon} text-2xl text-navy-900`}></i>
              </div>
              
              <h4 className="text-xl font-bold text-white mb-4">
                {contact.title}
              </h4>
              
              <p className="text-gray-300 leading-relaxed whitespace-pre-line">
                {contact.info}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
